module.exports = "/lucky-balls/img/bigball/BigBall_021.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/bigball/BigBall_021.png
// module id = 916
// module chunks = 0